
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForceSwellRelative as ObiForceSwellRelativeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-force-swell-relative.js';
 
 
 

 
 export const ObiForceSwellRelative = createComponent({
   react: React,
   tagName: 'obi-force-swell-relative',
   elementClass: ObiForceSwellRelativeElement,
   events: {
     
   }
  });
 
 